var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCustomer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.552,
    height: 13.08,
    viewBox: "0 0 26.552 13.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-user-button",
    transform: "translate(-247.89 -242.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-add",
    transform: "translate(248.579 241.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11164",
    "data-name": "Path 11164",
    d: "M169.391,81.116v-2.7h-1.824v2.7h-2.736v1.8h2.736v2.7h1.824v-2.7h2.736v-1.8Z",
    transform: "translate(-146.264 -76.518)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Customer_ic",
    transform: "translate(-0.688 0.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.721,42.349c1.529,0,2.718-1.586,2.718-3.227v-.514a2.72,2.72,0,1,0-5.437,0v.514C6,40.763,7.192,42.349,8.721,42.349Zm-5.446.531a1.864,1.864,0,0,0,1.633-1.744v-.872a1.637,1.637,0,1,0-3.267,0v.872A1.884,1.884,0,0,0,3.275,42.88Zm9.787,2.181a.232.232,0,0,0,0-.025,2.1,2.1,0,0,0-.059-.3,0,0,0,0,0,0,0,1.865,1.865,0,0,0-.3-.609h0a3.5,3.5,0,0,0-1.17-.985,1.29,1.29,0,0,0-.629-.251c-.3,0-.563.234-1,.639h0l-.4.369c-.014.014-.448.626-.773.626s-.758-.612-.773-.626l-.4-.369h0c-.442-.406-.7-.639-1-.639a1.182,1.182,0,0,0-.629.251,4.1,4.1,0,0,0-1.171.981h0v0a1.865,1.865,0,0,0-.295.6l0,.006a2.16,2.16,0,0,0-.059.3.257.257,0,0,1,0,.028,3.022,3.022,0,0,0-.019.333v2.4c0,.775.292,1.09,1.09,1.09h6.538c.8,0,1.09-.3,1.09-1.09v-2.4a3.065,3.065,0,0,0-.019-.33Zm1.114-2.181a1.864,1.864,0,0,0,1.633-1.744v-.872a1.637,1.637,0,1,0-3.267,0v.872A1.884,1.884,0,0,0,14.176,42.88ZM1.24,44.061A2.358,2.358,0,0,0,0,46.157c0,.01,0,1.082,0,1.09,0,.791.266,1.09,1.09,1.09H3.271v-3.27l-.545-.545C2.149,44.014,1.664,43.821,1.24,44.061Zm2.03,1.006C3.282,45.078,3.271,44.808,3.271,45.067Zm14.171,1.09a2.358,2.358,0,0,0-1.24-2.1c-.423-.24-.908-.048-1.485.462l-.545.545v3.27h2.182c.824,0,1.09-.3,1.09-1.09C17.443,47.239,17.442,46.167,17.442,46.157Zm-3.27-1.09C14.172,44.808,14.16,45.078,14.172,45.067Z",
    transform: "translate(0 -35.8)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomer);
export default __webpack_public_path__ + "static/media/addCustomer.efbbcd5b23ac192e9aa35d508c6fa365.svg";
export { ForwardRef as ReactComponent };